import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IdleReturnValue } from '../models';
import { Observable, interval, merge } from 'rxjs';
import { map, scan, shareReplay, startWith, take } from 'rxjs/operators';
import { LoggerService, shareReplayRefCount } from '@adreno-common';
import { IdleService } from '../services';

@Component({
  selector: 'app-idle-check-modal',
  templateUrl: './idle-check-modal.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IdleCheckModalComponent implements OnInit {
  private tick$ = interval(1000).pipe(
    startWith(-1),
    map((tick) => tick + 1),
    shareReplayRefCount()
  );
  viewModel$!: Observable<ViewModel>;

  constructor(
    private activeModal: NgbActiveModal,
    private idleSvc: IdleService,
    private logger: LoggerService
  ) {}

  private initViewModel() {
    this.viewModel$ = merge<Partial<ViewModel>>(
      this.tick$.pipe(map((tick) => ({ tick })))
    ).pipe(scan((acc, value) => ({ ...acc, ...value }), {} as ViewModel));
  }

  ngOnInit(): void {
    this.logger.info('IdleCheckModalComponent', 'ngOnInit')();
    this.initViewModel();
  }

  returnToWork() {
    this.tick$.pipe(take(1)).subscribe((tick) => {
      this.logger.warn('IdleCheckModalComponent', 'returnToWork', { tick })();
      this.idleSvc.returnToWork();
      this.activeModal.close('returning' as IdleReturnValue);
    });
  }

  stillHere() {
    this.tick$.pipe(take(1)).subscribe((tick) => {
      this.logger.warn('IdleCheckModalComponent', 'stillHere', { tick })();
      this.activeModal.close('still-here' as IdleReturnValue);
    });
  }
}

interface ViewModel {
  tick?: number;
}
